import Switch from 'components/ui/Switch';
import FloatingLabelInput from 'components/ui/FloatingLabelInput';
import { TimeDuration } from 'components/ui/time-duration';
import { MAXIMUM_ALLOWED_MINUTES } from 'constants/general';
import { t } from 'services/i18n.service';
import { convertToSeconds, splitDurationSeconds } from 'utils/helpers';

interface HabitDurationCompletionProps {
  useTimer: boolean;
  setUseTimer: (value: boolean) => void;
  durationSeconds: number;
  onDurationChange: (seconds: number | null) => void;
  completionRequirements: string;
  onCompletionRequirementsChange: (value: string) => void;
}

const HabitDurationCompletion: React.FC<HabitDurationCompletionProps> = ({
  useTimer,
  setUseTimer,
  durationSeconds,
  onDurationChange,
  completionRequirements,
  onCompletionRequirementsChange
}) => {
  const getDurationValue = () => {
    const { minutes, seconds } = splitDurationSeconds(durationSeconds);
    return { hours: 0, minutes, seconds };
  };

  const handleDurationChange = (
    time: { hours: number; minutes: number; seconds: number } | null
  ) => {
    const value = time ? convertToSeconds(time.minutes, time.seconds) : null;
    onDurationChange(value);
  };

  return (
    <div className='flex flex-col ~gap-1/2'>
      {/* Use Timer Toggle */}
      <Switch
        checked={useTimer}
        onChange={setUseTimer}
        label={t('use_timer')}
        labelPosition='right'
      />

      {/* Duration - Using TimeDuration Component */}
      {useTimer ? (
        <div className='flex flex-col ~gap-1/2'>
          <TimeDuration
            initialValue={getDurationValue()}
            onChange={handleDurationChange}
            showHours={false}
            showSeconds={true}
            size='small'
            className='w-fit'
            maxMinutes={MAXIMUM_ALLOWED_MINUTES}
          />
        </div>
      ) : (
        <FloatingLabelInput
          type='text'
          placeholder=''
          value={completionRequirements}
          onChange={(e) => onCompletionRequirementsChange(e.target.value)}
          size='small'
          label={t('settings_page.habit_finishes_when')}
          inputClassName='~px-2/4'
        />
      )}
    </div>
  );
};

export default HabitDurationCompletion;
